import { gql } from '@apollo/client/index.js'

export const APP_WIDGET_QUERY = gql`
query AppWidgetQuery($locale : String! $preview : Boolean!) {
  appWidget :json(id:"5cJhxXLT1ybrC7lgAQItHU", locale : $locale, preview : $preview) {
    content
  }
}`
